import * as types from './mutation-types'

// accion para cambiar data modalidad
export const setTorneo = ({ commit }, data) => {
  commit(types.SET_TORNEO, data)
}

// accion para cambiar data modalidad
export const setCompetition = ({ commit }, data) => {
  commit(types.SET_COMPETITION, data)
}

// accion para SETAR MODALIDAD TORNEO
export const setModalidadTorneo = ({ commit }, data) => {
  commit(types.SET_MODALIDAD_TORNEO, data)
}

// accion para SETAR partidos del torneo
export const setMatchesTorneo = ({ commit }, data) => {
  commit(types.SET_MATCHES_TORNEO, data)
}

// accion para SETAR partidos del torneo
export const setEstadiosMatches = ({ commit }, data) => {
  commit(types.SET_ESTADIOS_PARTIDOS, data)
}

// accion para SETAR partidos del torneo
export const setJornadasMatches = ({ commit }, data) => {
  commit(types.SET_JORNADAS_PARTIDOS, data)
}

// accion para SETAR partidos del torneo
export const setFixturesTorneo = ({ commit }, data) => {
  commit(types.SET_FIXTURES_TORNEO, data)
}
